import { BRAND } from "@/brand";

export default function WhatsAppButton() {
  return (
    <a
      href={BRAND.whatsappLink}
      target="_blank"
      rel="noreferrer"
      aria-label="WhatsApp Golf Motion Lab"
      className="fixed bottom-6 right-6 z-50 h-14 w-14 rounded-full bg-[#25D366] text-white flex items-center justify-center shadow-[0_8px_30px_rgb(37,211,102,0.35)] hover:scale-105 active:scale-95 transition-transform"
    >
      <svg viewBox="0 0 24 24" width="28" height="28" fill="currentColor" aria-hidden>
        <path d="M20.52 3.48A11.87 11.87 0 0012.07 0C5.43 0 .06 5.37.06 12c0 2.11.55 4.17 1.6 5.99L0 24l6.18-1.62A12 12 0 0012.07 24C18.7 24 24 18.63 24 12c0-3.18-1.24-6.17-3.48-8.52zM12.07 21.8c-1.95 0-3.86-.52-5.53-1.51l-.4-.24-3.66.96.98-3.57-.26-.37A9.8 9.8 0 012.25 12c0-5.43 4.4-9.85 9.82-9.85 2.62 0 5.08 1.02 6.93 2.88A9.79 9.79 0 0121.91 12c0 5.43-4.42 9.8-9.84 9.8zm5.66-7.33c-.31-.16-1.83-.9-2.12-1-.28-.1-.49-.16-.7.16s-.8 1-.98 1.2c-.18.2-.36.23-.67.08-.31-.16-1.3-.48-2.49-1.53-.92-.82-1.54-1.83-1.72-2.14-.18-.31-.02-.48.14-.63.14-.14.31-.36.46-.54.15-.18.2-.31.31-.51.1-.2.05-.38-.03-.54-.08-.16-.7-1.68-.96-2.3-.25-.6-.51-.52-.7-.53h-.6c-.21 0-.54.08-.82.38-.28.31-1.08 1.05-1.08 2.57s1.1 2.98 1.26 3.18c.16.21 2.17 3.3 5.27 4.63.74.32 1.32.51 1.77.65.74.23 1.41.2 1.94.12.59-.09 1.83-.75 2.08-1.47.26-.72.26-1.34.18-1.47-.08-.13-.28-.21-.59-.37z"/>
      </svg>
    </a>
  );
}
